import { render, staticRenderFns } from "./myWorks.vue?vue&type=template&id=a748589a&"
import script from "./myWorks.vue?vue&type=script&lang=js&"
export * from "./myWorks.vue?vue&type=script&lang=js&"
import style0 from "./myWorks.vue?vue&type=style&index=0&id=a748589a&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a748589a')) {
      api.createRecord('a748589a', component.options)
    } else {
      api.reload('a748589a', component.options)
    }
    module.hot.accept("./myWorks.vue?vue&type=template&id=a748589a&", function () {
      api.rerender('a748589a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/myWorks/myWorks.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/myWorks/myWorks.vue
// module id = K1gM
// module chunks = 0